export const title = {
    'en': 'Data Processing',
    'zh-tw': '數位資料處理'
};

export const conversion = {
    'en': 'convert [before][data] to [after]',
    'zh-tw': '[before][data]轉成[after]'
};

export const Binary = {
    'en': 'binary',
    'zh-tw': '二進制'
};

export const Octal = {
    'en': 'octal',
    'zh-tw': '八進制'
};

export const text_isUppercase ={
    'en': '[TEXT] first text is?',
    'zh-tw': '[TEXT]第1字元是?'
};

export const textisLowercase ={
    'en': 'Lowercase',
    'zh-tw': '小寫'
};

export const textisNumber ={
    'en': 'Number',
    'zh-tw': '數字'
};

export const textisOther={
    'en': 'Other text',
    'zh-tw': '其他文字'
};

export const textisUppercase ={
    'en': 'Uppercase',
    'zh-tw': '大寫'
}
export const Decimal = {
    'en': 'decimal',
    'zh-tw': '十進制'
};

export const Hexadecimal = {
    'en': 'hexadecimal',
    'zh-tw': '十六進制'
};

export const substring = {
    'en': 'substring [data] pos1 [start] pos2 [finish]',
    'zh-tw': '[data]第[start]到[finish]值'
};

export const startsWith = {
    'en': '[data] starts with [text]?',
    'zh-tw': '[data]用[text]開頭?'
};

export const endsWith = {
    'en': '[data] ends with [text]?',
    'zh-tw': '[data]用[text]結尾?'
};

export const replaceAll = {
    'en': 'replace all the [originalText] in [data] with [replaceText]',
    'zh-tw': '把[data]內所有的[originalText]取代成[replaceText]'
};

export const repeat = {
    'en': 'repeat [data] [number] times',
    'zh-tw': '[data]重複[number]次'
};

export const trim = {
    'en': 'trim [data]',
    'zh-tw': '移除[data]空白字元'
};

export const uppercase = {
    'en': 'uppercase [data]',
    'zh-tw': '[data]轉成大寫'
};

export const lowerCase = {
    'en': 'lowercase [data]',
    'zh-tw': '[data]轉成小寫'
};

export const FormConverNum = {
    'en': "convert[VALUE]from ([F_BEGIN],[F_END]) to ([T_BEGIN],[T_END])",
    'zh-tw': "轉換[VALUE]從([F_BEGIN],[F_END])到([T_BEGIN],[T_END])",
};

export const fullwidthToHalfwidth = {
    'en': 'convert fullwidth [data] to halfwidth',
    'zh-tw': '全形字[data]轉換為半形字'
};

export const halfwidthToFullwidth = {
    'en': 'convert halfwidth [data] to fullwidth',
    'zh-tw': '半形字[data]轉換為全形字'
};